import React, { Component } from 'react'
import SingleCard from './SingleCard';
import { Link } from "react-router-dom"
import { Row,Col, Card, Image } from 'react-bootstrap'

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import DeleteDraftModal from './DeleteDraftModal';

// const FETCH_SECTIONSCATEGORY = gql`
//   query($institution_id: Int!) {
//     getSectionCategories(institution_id: $institution_id) {
//       id
//       section_category
//       package_id
//       category_id
//       branch_ids
//       class_ids
//       section_ids
//       branch_id_values
//       class_id_values
//       section_id_values
//       package_name
//     }
//   }
// `;

const FETCH_SECTIONS = gql`
  query($institution_id: Int!) {
    getSections(institution_id: $institution_id) {
      id
      section_name
      category_id
      branch_id
      section_category_id
      category_name
      branch_name
      high_difficult
      difficult
      moderate
      easy
    }
  }
`;

const FETCH_CATEGORIES = gql`
  query($institution_id: Int!) {
    getCategories(institution_id: $institution_id) {
        category_name
      id
      high_difficult
      difficult
      moderate
      easy
      exams_covered
      branch_ids
      section_ids
      section_names
      branch_names
    }
  }
`;

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
         questionTypes{
            id
            questiontype
            
        }
        questionTheory{
          id
          question_theory
          
      }
      complexity{
          id
          complexity
          
      }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                }
                class
            }
        }
      exams{
          id
          exam
          exam_subjects{
            subject_id
            no_of_questions
          }
      }
      
    }
  }
`;

const FETCH_SAVED_PAPERS = gql`
  query($institution_id: Int!) {
    getSavedPapers(institution_id: $institution_id) {
        id
        name
        exam_type
        no_of_sets
        start_time
        end_time
        is_completed
        class
        section
        branch
        type
        class_id
        exam_model_id
        is_partexam
        mains_2021
        timestamp
        estatus
        sub_exam_type
        total_question_count
        exam_questions{
            id
            subject
            chapter
            question
            qtype
            option1
            option2
            option3
            option4
            chapter_name
            complexity
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
        }
    }
  }
`;

const DELETE_DRAFT_PAPER = gql`
  mutation($exam_paper_id: ID) {
    deleteDraftPaper(exam_paper_id: $exam_paper_id)
  }
`;


class CardGroupComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {

            data: this.props.CustomPatternQuestionsData,
            is_draft : "1",
            deleteMessageText:"",
            savedPapers:[],
            savedPapers:[],
            error4:'',
            loading4:false,
            deleteModalShow: false,
            curentDeletePaper:'',
            spinnerStatus: "",
        }
        console.log("draft",this.state.is_draft);
        this.onClickEdit = this.onClickEdit.bind(this);
    }
    componentDidMount(){
        let savedPapers = this.props.getSavedPapers;
        let loading4 = savedPapers.loading;
        let error4 = savedPapers.error;

        this.setState({
            savedPapers:savedPapers
        });
        console.log("hhh",savedPapers)
    }
    examImageFunction = (data) => {
        console.log("examImageFunction", data);
        if (data == 1) {
            return (require('../../../../images/Neet-Exam.png'));
        } else if (data == 2) {
            return (require('../../../../images/Jee(Mains)-Exam.png'));
        }
        //for mbipc..image not given
        else {
            return (require('../../../../images/Neet-Exam.png'));
        }
    }

    

    examType = (type) => {
        console.log("type", type);
        if (type == 1) {
            return ("NEET")
        } else if (type == 2) {
            return ("JEE")
        } else{
            return ("EAMCET")
        }
    }

    handleShowModal =  (paper) => {
        this.setState({
            deleteModalShow: true,
            curentDeletePaper:paper
        });
    }
    closePopup=()=>{
        this.setState({
            deleteModalShow:false
        })
    }
    handleDelete = async () => {
        this.setState({
            spinnerStatus:"1"
        });
        await this.props.deleteDraftPaper({
            variables: {
                exam_paper_id: this.state.curentDeletePaper.id
            },
            update: (store, { data }) => {
                console.log("datadatadatadata",data)
                if (data.deleteDraftPaper == true) {
                    this.setState({
                        is_draft: 0,deleteMessageText:"Deleted Successfully...",spinnerStatus:""
                    });
                    const data1 = store.readQuery({
                        query: FETCH_SAVED_PAPERS,
                        variables: {
                          institution_id: parseInt(Cookies.get("institutionid"))
                        }
                      });
                      console.log("result.data.getInstituteQuestions", data1);
                      //this.forceUpdate()
                      window.location.reload(true)
                     
                }
            }
            
          });

    }


    onClickEdit(paper, groupsData) {
        let item = {}
        groupsData.map(row => {
            if (row.branch_names == paper.branch && row.section_names == paper.section) {
                item = row;
            }
        });
        console.log("pppooo", paper);
        console.log("groupsData", groupsData);
        this.props.history.push("/questions/create-question-paper/own-question-paper/customEdit", {
            edit: true,
            examDetails: paper,
            globals: this.props.globals.globals,
            groupsData: item,
        });
    }
    render() {
        console.log("Cookies.get", Cookies.get("institutionid"));
        const getSections = this.props.getSections;
        const loading1 = getSections.loading;
        const error1 = getSections.error;

        const getCategories = this.props.getCategories;
        const loading2 = getCategories.loading;
        const error2 = getCategories.error;

        const globals = this.props.globals;
        const loading3 = globals.loading;
        const error3 = globals.error;

        const savedPapers = this.props.getSavedPapers;
        const loading4 = savedPapers.loading;
        const error4 = savedPapers.error;



        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error3 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error4 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (loading1 || loading2 || loading3) return (

            <div className="justify-content-center d-flex align-items-center w-100">
                <div class="spinner-border text-success text-center my-4"></div>
            </div>
        );

        //console.log("getSections", getSections.getSections);
        //const groupsData = getSections.getSections;
        const groupsData = getCategories.getCategories.filter((a) => a.section_ids != "" && a.branch_ids != "");
        console.log("getCategoriesglobals", getCategories.getCategories,
            globals.globals.exams
        );

        const savedPapersData = savedPapers.getSavedPapers;

        if (savedPapersData != undefined) {
            console.log("hello", savedPapersData)
        }

        console.log("ssssssssss",this.state)
        return (
            <React.Fragment>
                {groupsData.map((item) => {
                    let sectionfindData = getSections.getSections.find((a) => a.category_id == item.id);
                    console.log("sectionfindData", sectionfindData);
                    //let categoryfindData = getCategories.getCategories.find((a) => a.id == item.category_id);
                    let examnamefindData = globals.globals.exams.find((a) => a.id == item.exams_covered);
                    let ename = "";
                    if (examnamefindData != undefined) {
                        ename = examnamefindData.exam;
                    }
                    let subArray = [];
                    examnamefindData.exam_subjects.map((item) => {
                        let findData = globals.globals.subjects.find((a) => a.id == item.subject_id);
                        subArray.push(findData.subject);

                    });
                    console.log("subArray", subArray);
                    return (
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="mb-3">
                            <Link
                                to={
                                    {
                                        pathname: "/questions/create-question-paper/own-question-paper",
                                        state: {
                                            //groupsData: item,
                                            groupsData: item,
                                            examname: ename,
                                            //categoryfindData: categoryfindData,
                                            categoryfindData: item,
                                            subjects: subArray,
                                            globals: globals.globals,
                                            img: this.examImageFunction(examnamefindData.id)
                                        }
                                    }
                                }
                            >
                                <Card className="single_card shadow-sm border-0 h-100">
                                    <Card.Header className="img_block bg-white">
                                        <Image
                                            //src={require('../../../../images/Neet-Exam.png')} 
                                            src={this.examImageFunction(examnamefindData.id)}
                                            alt="img" />
                                    </Card.Header>
                                    <Card.Body className="content_block pt-5">
                                        <h6 className="title text-uppercase">
                                            {/* {item.section_category} */}
                                            {ename}
                                        </h6>
                                        <div className="class_section_names">{"Category-" + item.category_name}, {"Branch-" + item.branch_names}, {"Section-" + item.section_names}</div>
                                        {/* <div className="description">{this.props.description}</div> */}
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    );
                })}

                {
                    loading4 ? 
                    (
                        <div className="justify-content-center d-flex align-items-center w-100">
                            <div class="spinner-border text-success text-center my-4"></div>
                        </div>
                    )
                    :
                    (
                        <>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-3 mb-4 d-flex align-items-center justify-content-between">
                                <h2 className="title h5 mb-0">Draft Question Papers</h2>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <div className="table-responsive">
                                <table id="papers">
                                    <tr>
                                        <th>Exam Name</th>
                                        <th>Exam Type</th>
                                        <th>No.Of.Questions</th>
                                        <th>Branch</th>
                                        <th>Class</th>
                                        <th>Section</th>
                                        <th>Date</th>
                                        <th>Edit Paper</th>
                                    </tr>
                                    {savedPapersData && savedPapersData.map(paper => (

                                        <tr>
                                            <td>{paper.name}</td>
                                            <td>{this.examType(paper.exam_type)}</td>
                                            <td>{paper.total_question_count}</td>
                                            <td>{paper.branch}</td>
                                            <td>{paper.class}</td>
                                            <td>{paper.section}</td>
                                            <td>{moment.unix(paper.timestamp).format("DD-MM-YYYY")}</td>
                                            <td><button class="btn btn-primary effect" onClick={() => this.onClickEdit(paper, groupsData)}>Edit Paper</button>
                                            <button class="btn btn-danger effect ml-1" onClick={() => this.handleShowModal(paper)}>Delete</button></td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                            {
                                this.state.deleteMessageText != "" ?
                                (<h6 className="text-center">{this.state.deleteMessageText}</h6>)
                                :
                                ("")
                            } 

                            <DeleteDraftModal
                                show={this.state.deleteModalShow} onHide={() => this.setState({ deleteModalShow: false })}
                                deletePaper={this.state.curentDeletePaper}
                                spinnerStatus={this.state.spinnerStatus}
                                handleDelete={this.handleDelete}
                                closePopup={this.closePopup}    
                            />
                        </Col>
                        </>
                    )
                }
                
            </React.Fragment>

        )
    }
}
export default withRouter(
    compose(
        graphql(FETCH_SECTIONS, {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy: 'network-only'
            }),
            name: "getSections"
        }),
        graphql(FETCH_CATEGORIES, {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy: 'network-only'
            }),
            name: "getCategories"
        }),
        graphql(FETCH_GLOBALS, {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy: 'network-only'
            }),
            name: "globals"
        }),
        graphql(FETCH_SAVED_PAPERS, {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
                fetchPolicy:'network-only',
            }),
            name: "getSavedPapers"
        }),
        graphql(DELETE_DRAFT_PAPER, {
            name: "deleteDraftPaper"
        }),
    )(CardGroupComponent)
);